import { TailscaleInstaller } from "./types";

export const tailscaleInstaller: TailscaleInstaller = {
  "iam-write": {
    items: {},
  },
};
